/* @flow */

import * as React from 'react';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import messages from 'src/shared/app/base/l10n/uiL10n';

import CrossIcon from 'src/shared/ui/component/icon/CrossIcon';

import styles from './Tag.style';
import { useIntl } from 'react-intl';

type Props = {
  children: React.Node,
  onClick?: ?() => void,
  handleDismiss?: ?() => void,
  isInactive?: boolean,
  isChecked?: boolean,
  'aria-label'?: string,
  ariaDescribedby?: string,
};

const useStyles = createUseThemeStyles(styles);

const TagButton = ({
  children,
  onClick,
  handleDismiss,
  isInactive,
  isChecked,
  'aria-label': ariaLabel,
  ariaDescribedby,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({
    isInactive,
    isChecked,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const hasDissmiss = !onClick && handleDismiss;
  const dismissBtn = hasDissmiss && <CrossIcon className={classes.dismiss} />;
  const label =
    ariaLabel ||
    (hasDissmiss && intl.formatMessage(messages.delete)) ||
    undefined;

  return (
    <button
      title={label}
      aria-label={label}
      className={classes.root}
      disabled={isInactive}
      onClick={handleDismiss || onClick}
      type="button"
      aria-pressed={onClick ? isChecked : undefined}
      aria-describedby={ariaDescribedby}
    >
      {children}
      {dismissBtn}
    </button>
  );
};

export default React.memo<Props>(TagButton);
